import * as React from "react";

const IconCaretDown: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="currentColor"><polygon fill="currentColor" points="7.5 1.125 3.75 4.5 0 1.125 0 0 7.5 0" transform="translate(.25)"/></svg>;
};

export default React.memo(IconCaretDown);
